import { validatePasswordPolicy, IPasswordValidationResult } from "common247";

export { validatePasswordPolicy };
export type IValidationResult = IPasswordValidationResult;
